import Vue from 'vue'
import sentryTool from '@/sentry'

function showErrMessage(callback, extra = {}, err) {
  console.error(err)
  try {
    callback && callback(err)
    // 非error类型即为后端返回的业务错误，上报为警告消息类型，级别为warning
    if (Object.prototype.toString.call(err) !== '[object Error]') {
      sentryTool.captureMessage('业务返回错误警告', {
        level: 'warning',
        extra: err
      })
    } else {
      // 逻辑处理错误，then中产生的错误，为Error类型，直接上报为错误
      sentryTool.captureException(err, { extra: extra })
    }
  } catch (e) {
    sentryTool.captureException(err, { extra: { ...extra, handleError: e } })
  }
}

Vue.prototype.$showError = function(callback = null, extra = {}) {
  if (Object.prototype.toString.call(callback) === '[object Object]') {
    extra = callback
    callback = null
  }
  return showErrMessage.bind(this, callback, extra)
}
